<template>
  <d2-container>
    <el-card class="filter-container" shadow="never">
      <div>
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
        <el-button style="float: right;margin-right: 15px" type="primary" @click="handleSearchList" size="small"> 查询搜索 </el-button>
        <el-button style="float: right; margin-right: 15px" @click="handleResetSearch" size="small"> 重置 </el-button>
      </div>
      <div style="margin-top: 15px">
        <el-form :inline="true" :model="listQuery" size="small" label-width="140px">
        <el-form-item label="名称：">
            <el-input v-model="listQuery.name" class="input-width" placeholder="名称" clearable></el-input>
        </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="listQuery.status" class="input-width" placeholder="全部" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
    </el-card>

        <el-button
      type="primary"
      size="medium"
      icon="el-icon-circle-plus"
      style="margin-top:10px"
      @click="handleAdd()"
    >
      添加
    </el-button>

    <div class="table-container">
    
      <el-table
        ref="orderTable"
        :data="list"
        style="width: 100%; margin: 10px 0 15px"
        v-loading="listLoading"
        border
        stripe
      >
        <el-table-column type="index" label="#" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="名称">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        
	  <el-table-column align="center" label="状态">
	    <template slot-scope="scope">
        <el-link v-if="scope.row.status == 1" :underline="false" type="success" disabled>正常</el-link>
        <el-link v-else type="danger" :underline="false" disabled>禁用</el-link>
	    </template>
	  </el-table-column>
	
    <el-table-column  align="center" label="操作" fixed="right">
      <template slot-scope="scope">
        <el-button size="small" type="primary" @click="handleDetail(scope.row)"> 修改信息 </el-button>
      </template>
    </el-table-column>
		
      </el-table>
    </div>
    <template slot="footer">
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :page-sizes="[5, 10, 15, 20, 30, 50]"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>

    <el-dialog title="属性" :visible.sync="dialogFormVisible"  width="20%" :before-close="handleClose">
      <el-form :model="form"  size="small" label-width="100px" ref="form" :rules="rules">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="form.name" style="width:50%" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="状态：">
          <el-switch
            style="display: block;line-height: 24px;"
            v-model="status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="禁用">
          </el-switch>
        </el-form-item>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>

  </d2-container>
</template>

<script>
import { list, saveOrUpdate } from "@/api/workbench/classes/index"
const defaultListQuery = {
  pageNum: 1,
  pageSize: 10,
  status: null,
  name: null,
}
const defaultForm = {
    id:null,
    name:'',
    status:null,
}
export default {
  name: "classesList",
  data() {
    return {
      rules: {
        name: [{ required: true, message: '请填写毕业年份', trigger: 'blur' }],
        status: [{ required: true, message: '请选择毕业年份状态', trigger: 'blur' }]
      },
      listQuery: Object.assign({}, defaultListQuery),
      listLoading: true,
      list: null,
      total: null,
      dialogFormVisible:false,
      form: Object.assign({}, defaultForm),
      status:true,
      statusOptions: [
        { label: "删除", value: 0 },
        { label: "正常", value: 1 }
      ]
    }
  },
  created() {
    this.getList()
  },
  watch: {
    listQuery: {
      handler(val) {
        Object.keys(val).forEach(key => {
          if (!val[key] && val[key] !== 0) val[key] = undefined
        })
      },
      deep: true
    }
  },
  methods: {
    handleSave(){
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.form.status=this.status?1:0
              saveOrUpdate(this.form).then(response =>{
                this.$message.success("信息更改成功!")
                 this.handleClose()
                 this.getList()
              })
          }else{
            return false;
          }
        });
    },
    handleClose(){
      this.dialogFormVisible=false
      this.getList()
    },
    handleAdd(){
      this.status=true
      this.form=Object.assign({}, defaultForm),
      this.dialogFormVisible=true
    },
    handleDetail(row) {
      this.dialogFormVisible=true
      this.form=row
      this.status=this.form.status==1?true:false
    },
    getList() {
      this.listLoading = true
      list(this.listQuery).then(response => {
        this.listLoading = false
        this.list = response.rows
        this.total = response.total
      })
    },

    handleResetSearch() {  
      this.listQuery = Object.assign({}, defaultListQuery)
    },
    handleSearchList() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer {
  /deep/ .el-drawer {
    width: 400px !important;
  }
}
.block{
  margin: 40% 0px;
  /deep/ ul.el-timeline{
    padding: 0px 0px 0px 15px;
  }
}
.input-width {
  width: 203px;
}
.el-button {
  margin-bottom: 10px;
}
/deep/ .el-dialog__body{
  padding: 0 10px;
}
  .check-but{
    width: 100%;
    background: #edf2ff;
    display: flex;
    flex-direction: row;
    justify-content:space-between;
    margin: 4px 0px;
  }

</style>
